﻿import React, { useState, useEffect, useRef, Fragment } from "react";
import lodash from "lodash";
const { get } = lodash;
import moment from "moment";
import { parseDate } from "../../../../Resources/Scripts/_Shared/parseDate";
import { pushToDataLayer } from "../dataLayer";

export const DropdownlistWithLabel = (props) => {
    const optionIdentifier = props.optionIdentifier ?? "Id";
    const optionText = props.optionText ?? "Text";
    const wrappingClass = `single-step__section single-step__section--dropdown`;

    const [openStatus, setOpenStatus] = useState(false);
    const [selectedItem, setSelectedItem] = useState({
        item: { Text: "Select", Id: 0 },
    });
    const [searchText, setSearchText] = useState("");
    const [searchVisible, setSearchVisible] = useState(false);
    const [emptyList, setEmptyList] = useState(false);

    const buttonRef = useRef(null);
    const wrapperRef = useRef(null);
    const searchRef = useRef(null);

    let selectedItemText =
        get(selectedItem.item, optionText) ?? selectedItem.item.PlateText ?? "";
    if (
        !selectedItemText ||
        (selectedItemText.length === 0 && props.optionTextFallback)
    ) {
        selectedItemText = get(selectedItem.item, props.optionTextFallback);
    }
    const newPrice =
        props.isAfterPriceChange &&
        selectedItem.item.UpcomingPriceChange?.MonthlyPrice
            ? `${selectedItem.item.OverviewText} ${selectedItem.item.UpcomingPriceChange?.MonthlyPrice} ${selectedItem.item.Currency}`
            : "";
    const selectedLocale =
        props.locale === "no"
            ? "nb"
            : props.locale === "se"
              ? "sv"
              : props.locale;
    const selectedLanguage = document
        .querySelector("html")
        .getAttribute("lang");
    const selectedDate = props?.selectedDate?.date
        ? parseDate(props.selectedDate.date)
        : null;
    const dropdownId = props.dropdownId ?? "options";
    const selectAnOptionText =
        selectedLanguage == "sv"
            ? "Välj ett alternativ"
            : selectedLanguage == "fi"
              ? "Valitse vaihtoehto"
              : selectedLanguage == "no"
                ? "Velg et alternativ"
                : "Select an option";

    useEffect(() => {
        //Make sure datalist options closes when scrolling on Chrome
        const scrollElement = props.scrollElement
            ? document.querySelector(props.scrollElement)
            : "";
        if (!scrollElement || !props.searchable) return;
        const onScroll = () => {
            if (searchRef?.current) searchRef.current.blur();
        };
        //Clean up code
        scrollElement.removeEventListener(
            "scroll",
            debounce(onScroll, 1000, true),
        );
        scrollElement.addEventListener(
            "scroll",
            debounce(onScroll, 1000, true),
            { passive: true },
        );
        return () =>
            scrollElement.removeEventListener(
                "scroll",
                debounce(onScroll, 1000, true),
            );
    }, []);

    useEffect(() => {
        if (props.value) {
            const name = get(props.value.item, optionText);
            if (props.searchable) setSearchText(name);
            setSelectedItem(props.value);
        }
    }, [props.value]);

    useEffect(() => {
        if (
            searchVisible &&
            buttonRef?.current?.childNodes[0].tagName.toUpperCase() === "INPUT"
        ) {
            setSearchText("");
            buttonRef.current.childNodes[0].focus();
        }
    }, [searchVisible]);

    useEffect(() => {
        if (!props.options.length || !props.searchable) return;
        if (
            props.options.filter((singleoption) => filterOptions(singleoption))
                .length === 0
        )
            setEmptyList(true);
        else setEmptyList(false);
        const items = props.options.filter((option) => {
            return filterOptions(option) && option;
        });
        const item = items.length === 1 ? items[0] : null;
        if (item) {
            //if (searchText !== item.name) setSearchText(item.name);
            selectItemHandler(item);
        }
    }, [searchText]);

    const debounce = (func, wait, immediate) => {
        let timeout;
        return function () {
            const context = this,
                args = arguments;
            const later = () => {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    const filterOptions = (singleoption) => {
        const name = singleoption.name ?? singleoption.Name ?? "";
        const uid = singleoption.uid ?? singleoption.Uid ?? "";
        const textToSearch = name + " " + uid;
        return textToSearch.toUpperCase().includes(searchText.toUpperCase());
    };

    const useOutsideAlerter = (button, wrapper) => {
        useEffect(() => {
            const handleClickOutside = (event) => {
                if (
                    wrapper.current &&
                    !wrapper.current.contains(event.target) &&
                    button.current &&
                    !button.current.contains(event.target)
                ) {
                    setSearchVisible(false);
                    setOpenStatus(false);
                }
            };
            document.addEventListener("mousedown", handleClickOutside);

            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [button, wrapper]);
    };
    useOutsideAlerter(buttonRef, wrapperRef);

    //const blurHandler = () => {
    //  if (!selectedItem) return;
    //  setSearchText(selectedItem.item.name);
    //}

    const openCloseHandler = () => {
        setOpenStatus(!openStatus);
        if (props.searchable) setSearchVisible(!searchVisible);
    };

    const datalistFocusHandler = () => {
        setSearchText("");
    };

    const selectItemHandler = (item) => {
        setOpenStatus(false);
        if (props.searchable) {
            setSearchVisible(false);
            setTimeout(() => {
                searchRef.current.blur();
            }, 100);
        }
        if (props.setValue && props.isSeasonTicket) {
            props.setValue({ item }, props.index);
        } else if (props.setValue) {
            props.setValue({ ...props.value, item }, props.index);
        }
        pushToDataLayer({
            event: "dropdownlist_change",
            label: props.text,
            value: item,
        });
    };

    const selectNativeItemHandler = (event) => {
        const selectedItem = props.options.filter(
            (item) =>
                get(item.item ? item.item : item, optionIdentifier) ===
                event.target.value,
        );
        if (selectedItem.length > 0) selectItemHandler(selectedItem[0]);
    };

    return (
        <div className={wrappingClass}>
            <label htmlFor={dropdownId} className="single-step__section__label">
                {props.text}
                {props.required ? "*" : ""}
            </label>
            <div className="single-step__section__dropdown-button-wrapper">
                {props.searchable ? (
                    <Fragment>
                        <input
                            type="text"
                            placeholder={
                                props.loading ? "" : props.searchPlaceholder
                            }
                            className="single-step__section__dropdown-button single-step__section__dropdown-button--select"
                            spellCheck="false"
                            ref={searchRef}
                            onFocus={datalistFocusHandler}
                            list="datalistoptions"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            disabled={
                                props.disabled || props.options.length === 0
                            }
                            aria-busy={props.loading}
                        />
                        <datalist id="datalistoptions">
                            {props.options.map((singleoption, index) => {
                                const name =
                                    singleoption.name ??
                                    singleoption.Name ??
                                    "";
                                const uid =
                                    singleoption.uid ?? singleoption.Uid ?? "";
                                return (
                                    <option
                                        key={uid}
                                        value={name + " " + uid}
                                    />
                                );
                            })}
                        </datalist>
                    </Fragment>
                ) : (
                    <select
                        id={dropdownId}
                        className="single-step__section__dropdown-button single-step__section__dropdown-button--select"
                        aria-label={selectAnOptionText}
                        onChange={(e) => selectNativeItemHandler(e)}
                        value={
                            selectedItem.item &&
                            (get(selectedItem.item, optionIdentifier) ??
                                selectedItem.item.Id)
                        }
                        disabled={props.disabled || props.options.length === 0}
                        aria-busy={props.loading}
                    >
                        {selectedItem.item &&
                            (get(selectedItem.item, optionIdentifier) ===
                                "00000000-0000-0000-0000-000000000000" ||
                                selectedItem.item.IsUnselected) && (
                                <option
                                    defaultValue={
                                        get(
                                            selectedItem.item,
                                            optionIdentifier,
                                        ) ?? selectedItem.item.Id
                                    }
                                    value="selected"
                                >
                                    {selectedItemText}
                                </option>
                            )}
                        {props.options.map((singleoption, index) => {
                            let extraPricingText = "";
                            if (
                                props.selectedDay &&
                                props.selectedDay > -1 &&
                                singleoption.WeekdayPrices
                            ) {
                                const dayPrice =
                                    singleoption.WeekdayPrices[
                                        props.selectedDay
                                    ];
                                extraPricingText = dayPrice
                                    ? ` - ${dayPrice} ${singleoption.Currency}`
                                    : "";
                            }
                            let singleOptionText =
                                get(singleoption, optionText) ??
                                get(singleoption.item, optionText);
                            if (
                                !singleOptionText ||
                                (singleOptionText.length === 0 &&
                                    props.optionTextFallback)
                            ) {
                                singleOptionText = get(
                                    singleoption,
                                    props.optionTextFallback,
                                );
                            }
                            if (
                                !singleOptionText ||
                                singleOptionText.length === 0
                            ) {
                                singleOptionText =
                                    singleoption.PlateText ??
                                    singleoption.Text ??
                                    "";
                            }
                            let startSellingDateText = "";
                            const startSellingDate =
                                moment(
                                    parseDate(singleoption.StartSellingDate),
                                ).add(6, "hours") ||
                                (singleoption.LastBookingEnds
                                    ? moment(
                                          parseDate(
                                              singleoption.LastBookingEnds,
                                          ),
                                      ).add(1, "days")
                                    : null);
                            if (
                                startSellingDate &&
                                moment(selectedDate).isBefore(
                                    startSellingDate,
                                    "day",
                                )
                            ) {
                                startSellingDateText = `${props.available} ${moment(startSellingDate).locale(selectedLocale).format("L")}`;
                            } else if (
                                singleoption.ParkingSpaceStatus &&
                                singleoption.ParkingSpaceStatus ===
                                    "NOT_AVAILABLE"
                            ) {
                                startSellingDateText = `${props.available} –`;
                            }
                            return (
                                <option
                                    disabled={startSellingDateText}
                                    value={
                                        get(singleoption, optionIdentifier) ??
                                        get(
                                            singleoption.item,
                                            optionIdentifier,
                                        ) ??
                                        singleoption.Id ??
                                        ""
                                    }
                                    key={index}
                                >
                                    {singleoption.Zone
                                        ? `${singleoption.Text} (${singleoption.Zone})${extraPricingText} ${startSellingDateText}`
                                        : `${singleOptionText} ${startSellingDateText}`}
                                </option>
                            );
                        })}
                    </select>
                )}
                <button
                    className={[
                        "single-step__section__dropdown-button",
                        props.searchable
                            ? "single-step__section__dropdown-button--searchable"
                            : null,
                        openStatus
                            ? "single-step__section__dropdown-button--active"
                            : null,
                        props.options.length === 0
                            ? "single-step__section__dropdown-button--empty"
                            : null,
                    ].join(" ")}
                    tabIndex={-1}
                    aria-invalid={
                        props.value && props.value.error ? true : null
                    }
                    onClick={openCloseHandler}
                    ref={buttonRef}
                    disabled={
                        !props.loading &&
                        (props.disabled || props.options.length === 0)
                    }
                    aria-busy={props.loading}
                >
                    {searchVisible ? (
                        <input
                            type="text"
                            placeholder={
                                props.loading ? "" : props.searchPlaceholder
                            }
                            value={searchText}
                            onKeyDown={(e) => {
                                if (e.key === " " || e.keyCode === 32) {
                                    e.preventDefault();
                                    setSearchText(searchText + " ");
                                }
                            }}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                    ) : (
                        <span>
                            {props.isAfterPriceChange &&
                            selectedItemText &&
                            newPrice
                                ? newPrice
                                : selectedItemText}
                        </span>
                    )}
                </button>
                {props.value && props.value.error && (
                    <div className="validation-error">{props.value.error}</div>
                )}
                {openStatus && props.options.length > 0 && (
                    <div
                        className="single-step__section__dropdown-selection"
                        onMouseDown={(e) => emptyList && e.preventDefault()}
                        ref={wrapperRef}
                    >
                        {emptyList ? (
                            <div className="single-step__section__dropdown-item single-step__section__dropdown-item--empty">
                                <span className="single-step__section__dropdown-item__text">
                                    {props.customerNotFound}
                                </span>
                            </div>
                        ) : (
                            props.options.map((singleoption, index) => {
                                if (
                                    props.searchable &&
                                    !filterOptions(singleoption)
                                )
                                    return;
                                let extraPricingText = "";
                                const isAfterPriceChangeSingleOption =
                                    singleoption.UpcomingPriceChange?.Validity
                                        ?.ValidFrom && selectedDate
                                        ? moment(
                                              singleoption.UpcomingPriceChange
                                                  ?.Validity?.ValidFrom,
                                          ).isSameOrBefore(selectedDate, "day")
                                        : false;
                                if (
                                    props.selectedDay &&
                                    props.selectedDay > -1 &&
                                    singleoption.WeekdayPrices
                                ) {
                                    const dayPrice =
                                        singleoption.WeekdayPrices[
                                            props.selectedDay
                                        ];
                                    extraPricingText = dayPrice
                                        ? ` - ${dayPrice} ${singleoption.Currency}`
                                        : "";
                                }
                                let singleOptionText =
                                    get(singleoption, optionText) ??
                                    get(singleoption.item, optionText);
                                if (
                                    !singleOptionText ||
                                    (singleOptionText.length === 0 &&
                                        props.optionTextFallback)
                                ) {
                                    singleOptionText = get(
                                        singleoption,
                                        props.optionTextFallback,
                                    );
                                }
                                if (
                                    !singleOptionText ||
                                    singleOptionText.length === 0
                                ) {
                                    singleOptionText =
                                        singleoption.PlateText ??
                                        singleoption.Text ??
                                        "";
                                }
                                let startSellingDateText = "";
                                const startSellingDate =
                                    moment(
                                        parseDate(
                                            singleoption.StartSellingDate,
                                        ),
                                    ).add(6, "hours") ||
                                    (singleoption.LastBookingEnds
                                        ? moment(
                                              parseDate(
                                                  singleoption.LastBookingEnds,
                                              ),
                                          ).add(1, "days")
                                        : null);
                                if (
                                    startSellingDate &&
                                    moment(selectedDate).isBefore(
                                        startSellingDate,
                                        "day",
                                    )
                                ) {
                                    startSellingDateText = `${props.available} ${moment(startSellingDate).locale(selectedLocale).format("L")}`;
                                } else if (
                                    singleoption.ParkingSpaceStatus &&
                                    singleoption.ParkingSpaceStatus ===
                                        "NOT_AVAILABLE"
                                ) {
                                    startSellingDateText = `${props.available} –`;
                                }
                                if (
                                    isAfterPriceChangeSingleOption &&
                                    singleoption.UpcomingPriceChange
                                        ?.MonthlyPrice
                                )
                                    singleOptionText = `${singleoption.OverviewText} ${singleoption.UpcomingPriceChange?.MonthlyPrice} ${singleoption.Currency}`;
                                return (
                                    <div
                                        key={index}
                                        className={[
                                            "single-step__section__dropdown-item",
                                            startSellingDateText &&
                                                "single-step__section__dropdown-item--notavailable",
                                            (!props.isSeasonTicket &&
                                                get(
                                                    singleoption.item ??
                                                        singleoption,
                                                    optionIdentifier,
                                                ) !== undefined &&
                                                get(
                                                    singleoption.item ??
                                                        singleoption,
                                                    optionIdentifier,
                                                ) ===
                                                    get(
                                                        selectedItem.item,
                                                        optionIdentifier,
                                                    )) ||
                                            selectedItemText ===
                                                singleOptionText
                                                ? "single-step__section__dropdown-item--selected"
                                                : "",
                                        ].join(" ")}
                                        onClick={() =>
                                            !startSellingDateText &&
                                            selectItemHandler(singleoption)
                                        }
                                    >
                                        {singleoption.Zone && (
                                            <span className="single-step__section__dropdown-item__zone">
                                                {singleoption.Zone}
                                            </span>
                                        )}
                                        <span className="single-step__section__dropdown-item__text">
                                            {singleOptionText}
                                            {extraPricingText}
                                        </span>
                                        {startSellingDateText && (
                                            <span className="single-step__section__dropdown-item__date">
                                                {startSellingDateText}
                                            </span>
                                        )}
                                        {Array.isArray(
                                            singleoption.Promotions,
                                        ) &&
                                            singleoption.Promotions.length >
                                                0 && (
                                                <div>
                                                    <img
                                                        className="single-step__section__dropdown-item__promo"
                                                        src={`/publicResources/icons/promo/${selectedLanguage}/Promotion2_${selectedLanguage}.svg`}
                                                    />
                                                </div>
                                            )}
                                    </div>
                                );
                            })
                        )}
                    </div>
                )}
            </div>
            {props.children}
        </div>
    );
};
